import type { ReactNode } from 'react'

import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'

type NuqsProviderProps = {
  children: ReactNode
}

/**
 * Адаптер nuqs под react-router 7. Должен рендериться ВНУТРИ <BrowserRouter> —
 * читает историю и search params через хуки роутера (docs/persist.md §1).
 */
export function NuqsProvider(props: NuqsProviderProps) {
  const { children } = props
  return <NuqsAdapter>{children}</NuqsAdapter>
}
